export default __webpack_public_path__ + "static/media/signing-document-rd.d890452b.jpg";